import { useEffect } from "react";

import { connect } from "react-redux";

import * as actions from "../../../../store/actions/index";

import { withRouter } from "../../../../shared/utility";

import { useParams, useNavigate } from "react-router-dom";

import { UserDetailsViewModel } from "../../../../viewmodels/setup/users/user/UserDetailsViewModel";
import UserDetailsForm from "../../../../components/forms/user/UserDetailsForm";

function UserDetails(props) {
  const { logout } = props;
  const navigate = useNavigate();

  let { userId } = useParams();

  const {
    createUser,
    updateUser,
    getUser,
    user,
    loading,
    emptyModal,
    changeUserPasswordAdmin,
    getUserBusinessForDropdown,
    userBusinessess
  } = UserDetailsViewModel(logout, userId);

  const onStartDependencides = async function () {
    getUser();
  };

  useEffect(() => {
    if (userId) {
      onStartDependencides();
    } 
    getUserBusinessForDropdown();
    
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">

      <div className="card-custom">
        {loading ? null : (
          <UserDetailsForm
            isEdit={userId}
            user={user}
            actionCall={(values) => {
              if (userId) {
                updateUser(values);
              } else {
                createUser(values);
              }
            }}
            onResetPassword={(payload) => {
              changeUserPasswordAdmin(user.id, payload);
            }}
            userBusinessess={userBusinessess}
          />
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserDetails)
);
